var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"processing-loader"},[_c('img',{attrs:{"src":_vm.spinner_icon}}),_vm._v(" Processing... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }